import { useQuery } from '@tanstack/react-query'
import { buildVersionedUrl } from '@/common/utils/buildVersionedUrl'

/**
 * Hook to fetch CSS content with ETag-based cache busting.
 * Uses React Query for caching and automatic state management.
 *
 * @param baseUrl - The base URL of the CSS file
 * @param options - Optional React Query options
 */
export default function useQueryCssContent(
	baseUrl: string,
	options?: { enabled?: boolean },
) {
	return useQuery({
		queryKey: ['cssContent', baseUrl],
		queryFn: async () => {
			const versionedUrl = await buildVersionedUrl(baseUrl)
			const response = await fetch(versionedUrl, { cache: 'no-store' })

			if (!response.ok) {
				throw new Error(`Failed to fetch CSS: ${response.statusText}`)
			}

			return response.text()
		},
		staleTime: 0, // Always check for new content
		...options,
	})
}
